import { LocalStorageKey } from '@/shared/config';
import type { ToothSliceGeometryMode } from '@/shared/graphics/medicalImageRender/MedicalImageRender';
import { safeLocalStorage } from '@/shared/lib';

import { parseToothSliceMode } from './parseToothSliceMode';

export type ToothSliceModeScope = 'tooth' | 'volume' | 'modal';

const STORAGE_KEY_BY_SCOPE: Record<ToothSliceModeScope, LocalStorageKey> = {
  tooth: LocalStorageKey.fhmprToothPageSliceMode,
  volume: LocalStorageKey.fhmprVolumeSliceMode,
  modal: LocalStorageKey.fhmprModalSliceMode,
};

export const readToothSliceMode = ({
  fallback,
  scope,
}: {
  scope: ToothSliceModeScope;
  fallback?: ToothSliceGeometryMode;
}): ToothSliceGeometryMode =>
  parseToothSliceMode(
    safeLocalStorage.getItem(STORAGE_KEY_BY_SCOPE[scope]),
    fallback,
  );

export const writeToothSliceMode = ({
  mode,
  scope,
}: {
  mode: ToothSliceGeometryMode;
  scope: ToothSliceModeScope;
}): void => {
  safeLocalStorage.setItem(STORAGE_KEY_BY_SCOPE[scope], mode);
};
